<template>
  <div class="business-container">
    <div class="business-title">业务覆盖省份</div>
    <div class="business-main" :style="{
      backgroundImage: `url(${bannerInfo.img})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }">
      <div class="business-content">
        <div class="business-content-map">
          <echartsMap />
        </div>
        <div class="business-content-list">
          <div class="business-content-item" :class="{ highlighted: highlightedProvince == item.provinceName }" v-for="item in teamList" :key="item.provinceName"
               @mouseenter="handleMouseenter(item.provinceName)"
               @mouseleave="handleMouseleave">
            <div class="info-name-list">
              <div class="info-name-icon"><img src="@/assets/images/address.png" alt=""/></div>
              <div class="info-name-txt" :title="`${item.provinceName}-${item.name}`">{{ item.provinceName }}-{{ handleChara(item.name,10) }}</div>
            </div>
            <div class="info-introduction" :title="item.introduction">{{ handleChara(item.introduction,115) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import {getBannerList} from "@/api/apiHome";
import {onMounted, onUnmounted, ref} from "vue";
import {getContactTeamList} from "@/api/apiContact";
import {handleChara} from "@/utils/title";
import echartsMap from './echartsMap.vue'
import {emitter} from '@/eventBus/eventBus'
const bannerInfo = ref({})
const teamList = ref([])
const highlightedProvince=ref("")
const queryBannerList = async () => {
  const {code, data} = await getBannerList(7)
  if (code === 200) {
    bannerInfo.value = data && data.length > 0 ? data[0] : {}
  }
}
const queryTeamList = async () => {
  const {code, data} = await getContactTeamList()
  if (code === 200) {
    teamList.value = data
  }
}
const handleMouseenter=(name)=>{
  emitter.emit('showMapColor',name)
}
const handleMouseleave=()=>{
  emitter.emit('showMapColor')
}
// 处理地图高亮事件
const handleMapHighlight = (province) => {
  highlightedProvince.value = province;
};

onMounted(() => {
  emitter.on('map-province-highlight', handleMapHighlight);
})
onUnmounted(() => {
  emitter.off('map-province-highlight');
})
queryTeamList()
queryBannerList()
</script>

<style lang="scss" scoped>
.business-container {
  margin-top: 70px;
}

.business-title {
  font-weight: bold;
  font-size: 28px;
  color: #242424;
  position: relative;
  text-align: center;
}

.business-title::after {
  content: "";
  position: absolute;
  bottom: -16px;
  left: 50%;
  transform: translateX(-50%);
  width: 52px;
  height: 4px;
  background: #0048A9;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.business-main {
  margin: 50px  0;
  padding: 20px 0;
  box-sizing: border-box;
}

.business-content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}

.business-content-map {
  margin-top: 25px;
  width: 700px;
  height: 487px;
}

.business-content-list {
  padding-right: 15px;
  margin-left: 15px;
  width: 460px;
  height: 538px;
  overflow-y: auto;
  /* 自定义滚动条 */
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #E3E3E3 transparent; /* Firefox */
}
/* Webkit浏览器滚动条样式 */
.business-content-list::-webkit-scrollbar {
  width: 5px; /* 滚动条宽度 */
}

.business-content-list::-webkit-scrollbar-track {
  background: transparent; /* 轨道背景 */
}

.business-content-list::-webkit-scrollbar-thumb {
  background: #E3E3E3; /* 滑块颜色 */
  border-radius: 5px; /* 圆角 */
  min-height: 136px; /* 最小高度（实际高度由内容决定） */
}

.business-content-item {
  padding: 10px;
  cursor: pointer;
  width: 450px;
  height: 134px;
  box-sizing: border-box;
  color: #242424;
  &:hover{
    border-radius: 8px;
    background-color: rgba(0, 72, 169, 0.08);
  }
}
.highlighted{
  border-radius: 8px;
  background-color: rgba(0, 72, 169, 0.08);
}
.info-name-list{
   display: flex;
  align-items: center;
}
.info-name-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.info-name-txt{
  font-weight: bold;
  font-size: 20px;
}
.info-introduction{
  margin-top: 8px;
  font-size: 14px;
}
</style>
